import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { docsRouterBasename, isDocsHost, isLocalDocsPath, isMarketingHost, isSharePath } from "./routes";
import "./index.css";

const el = document.getElementById("root");
if (!el) throw new Error("root element missing");

// A tab open across a deploy asks for chunks the new build deleted, and the
// page blanks. Reload once per build onto the new shell. The key is this
// build's entry URL (content-hashed), so a chunk missing from the new build
// too cannot loop, however slow the reload. No storage, no guard, no reload.
window.addEventListener("vite:preloadError", (event) => {
  try {
    if (sessionStorage.getItem("motif:chunk-reload") === import.meta.url) return;
    sessionStorage.setItem("motif:chunk-reload", import.meta.url);
  } catch {
    return;
  }
  event.preventDefault();
  window.location.reload();
});

const hostname = window.location.hostname;
const pathname = window.location.pathname;
const docs = isDocsHost(hostname) || isLocalDocsPath(pathname);

// Docs (docs.motiftrace.com) and marketing (motiftrace.com) must paint without
// Clerk. The live homepage LCP on Slow 4G was 2.7s because App waited on
// isLoaded first (web-performance-auditor, 2026-08-16). Dynamic import keeps
// @clerk/react out of the first public chunk.
if (docs) {
  void import("./pages/Docs").then(({ DocsApp }) => {
    createRoot(el).render(
      <StrictMode>
        <BrowserRouter basename={docsRouterBasename(hostname, pathname)}>
          <DocsApp />
        </BrowserRouter>
      </StrictMode>,
    );
  });
} else if (isMarketingHost() || isSharePath(pathname)) {
  void import("./MarketingApp").then(({ MarketingApp }) => {
    createRoot(el).render(
      <StrictMode>
        <BrowserRouter>
          <MarketingApp />
        </BrowserRouter>
      </StrictMode>,
    );
  });
} else {
  void import("./product").then(({ mountProduct }) => {
    mountProduct(el);
  });
}
